import { CustomAuthorizerEvent, CustomAuthorizerResult } from "aws-lambda";
import { injectable } from "inversify";

import { Handler } from "../handler";

@injectable()
export abstract class AuthorizerHandler extends Handler<CustomAuthorizerEvent, CustomAuthorizerResult> {
  protected async processEvent(event: CustomAuthorizerEvent): Promise<CustomAuthorizerEvent> {
    console.log("processEvent", event);
    return event;
  }

  protected async processResponse(response: CustomAuthorizerResult): Promise<CustomAuthorizerResult> {
    console.log("processResponse", response);
    return response;
  }

  protected async processError(err: Error): Promise<CustomAuthorizerResult> {
    console.log("processError", err);
    throw err;
  }
}
